rjm.ui.ChartBuilderDimensionValuesView = Backbone.View.extend(
  tagName: "li"
  className: "well well-small span4"

  events:
    "click #addAll": "addAllCategories"
    "change #categoryValueSelector": "selectionChanged"

  initialize: (options) ->
    if not options.hasOwnProperty("category") or
        not options.hasOwnProperty("categoryIndex") or
        not options.hasOwnProperty("chartModel")
      throw "InvalidConstructorArgs - ChartBuilderSlicerListView"

    _.bindAll this, "addAllCategories", "selectionChanged", "addSelectedScroll", "generateTemplateData", "render", "renderGrouperName"
    #set incoming options
    @category = options.category
    @categoryIndex = options.categoryIndex
    @chartModel = options.chartModel
 
    #initilize local variables
    @sid = @category.get("column").get("sid")

    return

  renderGrouperName: () ->
    grouper = @chartModel.get('series').at(0).get('trend').get('slicers').getBySid(@category.get("column").get("sid"))
    name = grouper.get('name')
    @$('#grouperName').text(name)


  addAllCategories: (e) ->
    e.preventDefault()
    @$('.selectedScroll').remove() #if we are adding all get rid of the scroll div
    @$('#categoryValueSelector').select2("val", "") #empty selection
    @$('#categoryValueSelector').select2("data", {id: -1, text: "All Values"})
    @$('#categoryValueSelector').trigger "change"
    @$(".select2-search-field").hide() #hide the search field
    @$("#addAll").attr("disabled", "disabled");

    
  selectionChanged: (e)->
    e.preventDefault()
    #check if we should activate the addAll button
    if +@$(e.target).val() is -1
      @category.addAllValues()
      return
    else
      @$(".select2-search-field").show()
      @$("#addAll").removeAttr("disabled")

    if e.added?
      @category.addValue e.added.id
    if e.removed?
      @category.removeValue e.removed.id
    
    if not _(@$(e.target).val()).isEmpty()
      @addSelectedScroll()

  addSelectedScroll: ->
    if @$('.selectedScroll').length
      @$(".selectedScroll").children().unwrap()
    @$(".select2-search-choice").wrapAll('<div class="selectedScroll" />')

  generateTemplateData: ->
    defer = $.Deferred()
    $.when(rjm.util.categoryValues.getCategoryDataForSid(@sid, @chartModel.get('clientId'))).done (data) =>
      obj = {}
      obj.columnValues = []
      if +@category.get("values")[0] is -1 #all values case: convert value 'key' to a number and see if it's -1
        obj.selectedValues = [{id: -1, text: "All Values"}]
      else if data.tooManyValues or _(data.categoryValues).size() is 0 #we don't have data but still need to set selected values array
        obj.selectedValues =  _(@category.get("values")).map (id) ->
          return id: id, text: id
      else #we have data
        obj.columnValues = data.categoryValues
        obj.selectedValues = _(@category.get("values")).map (id) ->
          if _(id).isNull()
            id = "[NULL]"
          else if _(id).isString() and _(id).isEmpty()
            id = "[blank]"
          return {
            id: id
            text: id
          }
      obj.tooManyValues = data.tooManyValues
      obj.name = @category.get("column").get("name")
      obj.categoryIndex = @categoryIndex
      obj.apiConnId = @chartModel.get('api_conn_id')
      obj.trid = @chartModel.get('series').at(0).get('trend').getId()
      timeFrame = @chartModel.get('timeFrame').convertRangeToDateObjects()
      obj.start = timeFrame.start?.toString('yyyy-MM-dd')
      obj.end = timeFrame.end?.toString('yyyy-MM-dd')
      defer.resolve obj
    defer.promise()

  render: ->
    @$el.addClass('blocked loading')

    $.when(@generateTemplateData()).done (obj) =>
      @$el.html ich.chartBuilderDimensionValues(obj)

      options = 
        data: obj.columnValues
        containerCssClass: 'list-mode' # This is to give it that list style.
        placeholder: "Please Select a Value"
        width: 'resolve'
        multiple: true
        formatSelection: (object, container) ->
          return object.text
        formatResult: (object, container, query) ->
          return _.escape(object.text)
        createSearchChoice: (term, data) ->
          if $(data).filter( -> return this.text.localeCompare(term) is 0 ).length is 0 
            return {id:term, text:term}
        formatNoMatches: (term) ->
          return "Please start typing a value to search"
      if obj.columnValues.length is 0
        options.query = rjm.util.categoryValues.select2QueryFunction(@sid, obj.apiConnId, obj.trid, obj.start, obj.end, @chartModel.get('clientId'))
          

      @$("#categoryValueSelector").select2 options
        
      @$("#categoryValueSelector").select2("data", obj.selectedValues) #build the selected values (calls the initSelection event)

      if obj.selectedValues?[0]?.id is -1
        @$("#addAll").attr("disabled", "disabled");
        @$(".select2-search-field").hide()
      else        
        @$(".select2-search-field").show()
        @$("#addAll").removeAttr("disabled") 
        
      @addSelectedScroll()

      @$el.removeClass('blocked loading')

    return @
)